import { Controller } from '@hotwired/stimulus';

import { optimizelyTrackUserEvent } from '../sdk/optimizely';

export default class extends Controller {
  // all Optimizely events are stored in feature_system/tracking.rb
  static values = { optimizelyEvent: String };

  logEvent() {
    if (this.optimizelyEventValue) {
      optimizelyTrackUserEvent(this.optimizelyEventValue);
    }
  }
}
